import React from "react";
import { t } from "i18next";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { toFixedWithoutRounding } from "../Utils/Toast";
import { Link, useLocation, useNavigate } from "react-router-dom";

const HomeAfterlogin = () => {
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div data-v-b19ae084 className="balance-details hidden-md-and-up">
      <div data-v-b19ae084 className="row MB-row pa-3 no-gutters">
        <div data-v-b19ae084 className="pa-2 pl-0 col col-4">
          <div data-v-b19ae084 className="row no-gutters">
            <div data-v-b19ae084 className="col">
              {user?.user?.username}
            </div>
          </div>
          <div
            data-v-b19ae084
            className="row d-flex align-center hidden-md-and-up no-gutters"
            style={{ gap: "5px" }}
          >
            <div data-v-b19ae084>
              <label data-v-b19ae084 className="text-capitalize balance">
                <span data-v-b19ae084>
                  ₹ {toFixedWithoutRounding(userCoins?.balance)}
                </span>
              </label>
              {/**/}
            </div>
            <div
              onClick={() => amounutRefresh()}
              data-v-b19ae084
              className="refresh-balance-icon"
            />
          </div>
        </div>
        <div data-v-b19ae084 className="d-flex align-center col col-8">
          <div data-v-b19ae084 className="row justify-space-around">
            {/* <div data-v-b19ae084>
              <Link
                data-v-b19ae084
                to="/vip/vipProfile"
                className="nav-item v-card v-card--link v-sheet theme--light"
                tabIndex={0}
              >
                <img
                  data-v-b19ae084
                  src="/assets/icon/bettingPass.svg"
                  className="img-nav-item"
                />
              </Link>
              <span data-v-b19ae084 className="nav-item-span">
                Big Pass
              </span>
            </div> */}
            <div data-v-b19ae084>
              <Link
                data-v-b19ae084
                to="/history/betting-history"
                className="nav-item v-card v-card--link v-sheet theme--light"
                tabIndex={0}
              >
                <img
                  data-v-b19ae084
                  src="/assets/new/betHistory.svg"
                  className="img-nav-item"
                />
              </Link>
              <span data-v-b19ae084 className="nav-item-span">
                {t("BetHistory")}
              </span>
            </div>
            {/**/}
            <div data-v-b19ae084>
              <Link
                data-v-b19ae084
                to="/bank/withdrawal"
                className="nav-item v-card v-card--link v-sheet theme--light"
                tabIndex={0}
              >
                <img
                  data-v-b19ae084
                  src="/assets/new/newWithdrawal.svg"
                  className="img-nav-item"
                />
              </Link>
              <span data-v-b19ae084 className="nav-item-span">
                {t("Withdrawal")}
              </span>
            </div>
            <div data-v-b19ae084>
              <Link
                data-v-b19ae084
                to="/bank/deposit"
                className="nav-item v-card v-card--link v-sheet theme--light"
                tabIndex={0}
              >
                <img
                  data-v-b19ae084
                  src="/assets/new/newDeposit.svg"
                  className="img-nav-item"
                />
              </Link>
              <span data-v-b19ae084 className="nav-item-span">
                {t("Deposit")}
              </span>
            </div>
          </div>
        </div>
      </div>
      {location?.pathname != "/" && (
        <div
          data-v-b19ae084
          className="row MB-row pa-2 viptier-details no-gutters level0"
        >
          <div data-v-b19ae084 className="col">
            <div data-v-b19ae084 className="row no-gutters">
              <div data-v-b19ae084 className="MB-left-col pr-4 col col-3">
                <div data-v-b19ae084 className="row justify-space-around">
                  <div
                    data-v-b19ae084
                    className="v-avatar rounded-0"
                    style={{
                      height: "90px",
                      "min-width": "90px",
                      width: "90px",
                    }}
                  >
                    <div
                      data-v-b19ae084
                      className="v-image v-responsive theme--light"
                    >
                      <div
                        className="v-responsive__sizer"
                        style={{ "padding-bottom": "110.115%" }}
                      />
                      <div
                        className="v-image__image v-image__image--cover"
                        style={{
                          "background-image":
                            'url("/assets/new/695365cf5616b.webp")',
                          "background-position": "center center",
                        }}
                      />
                      <div
                        className="v-responsive__content"
                        style={{ width: "435px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-b19ae084 className="MB-right-col d-flex col col-9">
                <div data-v-b19ae084 className="row no-gutters">
                  <span
                    data-v-b19ae084
                    style={{
                      "-webkit-text-transform": "uppercase",
                      "text-transform": "uppercase",
                      "-webkit-text-align": "center",
                      "text-align": "center",
                    }}
                  >
                    VIP 1
                  </span>
                </div>
                <div data-v-b19ae084 className="row no-gutters">
                  <div
                    data-v-b19ae084
                    role="progressbar"
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-valuenow={0}
                    className="v-progress-linear v-progress-linear--visible theme--light"
                    size={20}
                    style={{ height: "4px" }}
                  >
                    <div
                      className="v-progress-linear__background viptier0"
                      style={{ opacity: "1", left: "0%", width: "100%" }}
                    />
                    <div className="v-progress-linear__buffer" />
                    <div
                      className="v-progress-linear__determinate black"
                      style={{ width: "0%" }}
                    />
                  </div>
                </div>
                <div
                  data-v-b19ae084
                  className="row progress-details-col no-gutters"
                >
                  <span data-v-b19ae084>LV 0</span>
                  <span data-v-b19ae084>{t("MoreToNextLevel")}</span>
                  <span data-v-b19ae084>LV 1</span>
                </div>
              </div>
            </div>
            <div data-v-b19ae084 className="row MB-btm-row px-3 no-gutters">
              <div data-v-b19ae084 className="col col-10">
                <span data-v-b19ae084 style={{ "font-size": "10px" }}>
                  {t("ViewVipDetails")}
                </span>
              </div>
              <div data-v-b19ae084 className="spacer" />
              <i
                data-v-b19ae084
                aria-hidden="true"
                className="v-icon notranslate mdi mdi-chevron-right theme--light white--text"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeAfterlogin;
